import { useState } from "react";

import CloudDownload from "@mui/icons-material/CloudDownload";
import CloudUpload from "@mui/icons-material/CloudUpload";
import HeadsetMic from "@mui/icons-material/HeadsetMic";
import Settings from "@mui/icons-material/Settings";
import SettingsSystemDaydream from "@mui/icons-material/SettingsSystemDaydream";
import { MenuList } from "@mui/material";

import { Divider } from "components/Divider";
import { DropDownMenu } from "components/TopNav/DropDownMenu";
import { MenuItemLink } from "components/TopNav/MenuItemLink";
import { MenuListItemText } from "components/TopNav/MenuListItemText";
import { NavListItemIcon } from "components/TopNav/NavListItemIcon";
import { TopNavIcon } from "components/TopNav/TopNavIcon";

import { i18n } from "services/i18nService";

import { usePrivileges } from "hooks/usePrivileges";

import { getLevel2Selections } from "views/Configuration/navigationStructure";

import { USER_PRIVILEGE } from "appConstants";

export function SettingsMenu() {
  const [anchor, setAnchor] = useState(null);

  const { hasPrivilegesOrIsAdmin, isAdmin, isSupport, userPrivilegesMap } =
    usePrivileges();
  const showActivityLog = hasPrivilegesOrIsAdmin(USER_PRIVILEGE.activityLog);
  const vendorItemPrivilege = getLevel2Selections("list").find(
    ({ routePart }) => routePart === "vendoritem"
  )?.privilege;
  const showConfiguration =
    hasPrivilegesOrIsAdmin([
      USER_PRIVILEGE.purchasingSettings,
      USER_PRIVILEGE.inventorySettings,
      USER_PRIVILEGE.salesSettings,
      USER_PRIVILEGE.editShipments,
      USER_PRIVILEGE.editSalesReps,
      USER_PRIVILEGE.viewWorkers,
      USER_PRIVILEGE.editWorkers,
      USER_PRIVILEGE.buildAssemblies,
      USER_PRIVILEGE.editCustomers,
      USER_PRIVILEGE.editItems,
      USER_PRIVILEGE.viewItems,
    ]) ||
    (vendorItemPrivilege &&
      (isAdmin || vendorItemPrivilege(userPrivilegesMap)));

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
    }
    setAnchor(null);
  }
  const openMenu = Boolean(anchor);
  const menuId = openMenu ? "settings-menu" : undefined;

  return (
    <>
      <TopNavIcon
        image="/images/tools_and_settings.svg"
        onClick={(e) => setAnchor(e.currentTarget)}
        functionText={i18n("iconAltText.toolsAndSettings")}
      />
      <DropDownMenu
        id={menuId}
        open={openMenu}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
      >
        <MenuList
          id="settings-list-grow"
          onKeyDown={handleListKeyDown}
          sx={{ px: 1 }}
        >
          {showConfiguration && (
            <div>
              <MenuItemLink
                to="/configuration/company/general"
                onClick={() => setAnchor(null)}
              >
                <NavListItemIcon>
                  <Settings />
                </NavListItemIcon>
                <MenuListItemText
                  primary={i18n("topNav.settingsMenu.settings")}
                />
              </MenuItemLink>
              <Divider />
            </div>
          )}
          <MenuItemLink to="/import" onClick={() => setAnchor(null)}>
            <NavListItemIcon>
              <CloudUpload />
            </NavListItemIcon>
            <MenuListItemText primary={i18n("topNav.settingsMenu.import")} />
          </MenuItemLink>
          <MenuItemLink to="/export" onClick={() => setAnchor(null)}>
            <NavListItemIcon>
              <CloudDownload />
            </NavListItemIcon>
            <MenuListItemText primary={i18n("topNav.settingsMenu.export")} />
          </MenuItemLink>
          <MenuItemLink to="/dataUtilities" onClick={() => setAnchor(null)}>
            <NavListItemIcon>
              <SettingsSystemDaydream />
            </NavListItemIcon>
            <MenuListItemText
              primary={i18n("topNav.settingsMenu.dataUtilities")}
            />
          </MenuItemLink>
          {isSupport && (
            <div>
              <Divider />
              <MenuItemLink
                to="/supportconsole"
                onClick={() => setAnchor(null)}
              >
                <NavListItemIcon>
                  <HeadsetMic />
                </NavListItemIcon>
                <MenuListItemText
                  primary={i18n("topNav.settingsMenu.support")}
                />
              </MenuItemLink>
            </div>
          )}
          {showActivityLog && (
            <>
              <Divider />
              <MenuItemLink to="/auditevent" onClick={() => setAnchor(null)}>
                <NavListItemIcon>
                  <CloudUpload />
                </NavListItemIcon>
                <MenuListItemText
                  primary={i18n("topNav.settingsMenu.activityLog")}
                />
              </MenuItemLink>
            </>
          )}
        </MenuList>
      </DropDownMenu>
    </>
  );
}
